module.exports = __webpack_public_path__ + "assets/176b6889b5cafe40439355d6f829ca93.mp3";